


// import React, { useEffect, useState } from 'react';
// import {
//   Box, Typography, Button, Dialog, DialogActions,
//   DialogContent, DialogTitle, TextField, IconButton,
//   LinearProgress, Checkbox, FormControlLabel,
//   CircularProgress,
// } from '@mui/material';
// import { Delete, Edit } from '@mui/icons-material';
// import TableComponent from '../../../Components/TableComponent/TableComponent';
// import { SnackBarComponent } from '../../../Components/snackBar/snackBar';
// import { LoadingSpinner } from '../../../Components/spinner/spinner';
// import { API_BASE_URL } from '../../../config';
// import api from '../../../api/axiosInterceptor';
// import axios from 'axios';

// export const SuperStaffManualVideosComponent = () => {
//   const [rows, setRows] = useState([]);
//   const [loading, setLoading] = useState(true);

//   const [snackbarOpen, setSnackbarOpen] = useState(false);
//   const [snackbarMessage, setSnackbarMessage] = useState('');
//   const [snackbarSeverity, setSnackbarSeverity] = useState('info');

//   const [openFormDialog, setOpenFormDialog] = useState(false);
//   const [isEditMode, setIsEditMode] = useState(false);
//   const [selectedVideo, setSelectedVideo] = useState(null);

//   const [formData, setFormData] = useState({
//     subject: '',
//     is_internal: false, // new checkbox field added here
//   });
//   const [selectedFile, setSelectedFile] = useState(null);
//   const [formErrors, setFormErrors] = useState({});

//   const [uploading, setUploading] = useState(false);
//   const [uploadProgress, setUploadProgress] = useState(0);

//   const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
//   const [deleteVideo, setDeleteVideo] = useState(null);

//   const columns = [
//     { id: 'slNo', field: 'slNo', headerName: 'Sl No.', width: 70 },
//     { id: 'subject', field: 'subject', headerName: 'Subject', width: 300 },
//     {
//       id: 'viewDetails',
//       field: 'viewDetails',
//       headerName: 'View Details',
//       width: 120,
//       renderCell: (params) =>
//         params.value ? (
//           <a href={params.value} target="_blank" rel="noopener noreferrer">
//             View Details
//           </a>
//         ) : (
//           'No File'
//         ),
//     },
//     {
//       id: 'is_internal',
//       field: 'is_internal',
//       headerName: 'Is Internal',
//       width: 100,
//       renderCell: (params) => (params.value ? 'Yes' : 'No'),
//     },
//     {
//       id: 'actions',
//       field: 'actions',
//       headerName: 'Actions',
//       width: 150,
//       renderCell: (params) => (
//         <>
//           <IconButton color="primary" onClick={() => handleEdit(params.row)} disabled={uploading}>
//             <Edit />
//           </IconButton>
//           <IconButton color="error" onClick={() => handleDeleteConfirmation(params.row)} disabled={uploading}>
//             <Delete />
//           </IconButton>
//         </>
//       ),
//     },
//   ];

//   useEffect(() => {
//     fetchVideos();
//   }, []);

//   const fetchVideos = () => {
//     setLoading(true);
//     axios
//       .get(`${API_BASE_URL}/home-notification/staff-manaual-vid/`)
//       .then((response) => {
//         const apiData = response.data.map((item, index) => ({
//           id: item.id || index,
//           slNo: index + 1,
//           subject: item.subject,
//           viewDetails: item.link || '',
//           is_internal: item.is_internal || false,
//         }));
//         setRows(apiData);
//         setLoading(false);
//       })
//       .catch((error) => {
//         console.error('Failed to fetch Manuals and Videos:', error);
//         setSnackbarMessage('Failed to load Manuals and Videos.');
//         setSnackbarSeverity('error');
//         setSnackbarOpen(true);
//         setLoading(false);
//       });
//   };

//   const handleSnackbarClose = () => setSnackbarOpen(false);

//   const handleAddVideo = () => {
//     setIsEditMode(false);
//     setFormData({ subject: '', is_internal: false });
//     setSelectedFile(null);
//     setFormErrors({});
//     setUploadProgress(0);
//     setOpenFormDialog(true);
//   };

//   const handleEdit = (video) => {
//     setIsEditMode(true);
//     setSelectedVideo(video);
//     setFormData({ subject: video.subject, is_internal: video.is_internal || false });
//     setSelectedFile(null);
//     setFormErrors({});
//     setUploadProgress(0);
//     setOpenFormDialog(true);
//   };

//   const handleDeleteConfirmation = (video) => {
//     setDeleteVideo(video);
//     setDeleteDialogOpen(true);
//   };

//   const handleDelete = () => {
//     api
//       .delete(`${API_BASE_URL}/home-notification/manaual-vid/${deleteVideo.id}/`)
//       .then(() => {
//         setSnackbarMessage('Manual or video deleted successfully.');
//         setSnackbarSeverity('success');
//         setSnackbarOpen(true);
//         fetchVideos();
//       })
//       .catch((error) => {
//         console.error('Delete failed:', error);
//         setSnackbarMessage('Failed to delete manual or video.');
//         setSnackbarSeverity('error');
//         setSnackbarOpen(true);
//       })
//       .finally(() => {
//         setDeleteDialogOpen(false);
//         setDeleteVideo(null);
//       });
//   };

//   const validateForm = () => {
//     const errors = {};
//     if (!formData.subject?.trim()) errors.subject = 'Subject is required';
//     if (!selectedFile && !isEditMode) errors.file = 'File is required';
//     if (selectedFile && selectedFile.size > 2 * 1024 * 1024) errors.file = 'File size must be less than 2MB';
//     setFormErrors(errors);
//     return Object.keys(errors).length === 0;
//   };

//   const handleFileChange = (e) => {
//     const file = e.target.files[0];
//     if (file && file.size > 2 * 1024 * 1024) {
//       setFormErrors((prev) => ({ ...prev, file: 'File size must be less than 2MB' }));
//       setSelectedFile(null);
//     } else {
//       setFormErrors((prev) => ({ ...prev, file: null }));
//       setSelectedFile(file);
//     }
//   };

//   const handleFormSubmit = async () => {
//     if (!validateForm()) return;

//     const form = new FormData();
//     form.append('subject', formData.subject);
//     form.append('is_internal', formData.is_internal);
//     if (selectedFile) form.append('link', selectedFile);

//     try {
//       setUploading(true);
//       setUploadProgress(0);

//       if (isEditMode) {
//         await api.patch(`${API_BASE_URL}/home-notification/manaual-vid/${selectedVideo.id}/`, form, {
//           headers: { 'Content-Type': 'multipart/form-data' },
//           onUploadProgress: (e) => setUploadProgress(Math.round((e.loaded * 100) / e.total)),
//         });
//         setSnackbarMessage('Manual or video updated successfully.');
//       } else {
//         await api.post(`${API_BASE_URL}/home-notification/manaual-vid/`, form, {
//           headers: { 'Content-Type': 'multipart/form-data' },
//           onUploadProgress: (e) => setUploadProgress(Math.round((e.loaded * 100) / e.total)),
//         });
//         setSnackbarMessage('Manual or video added successfully.');
//       }

//       setSnackbarSeverity('success');
//       setSnackbarOpen(true);
//       fetchVideos();
//       setOpenFormDialog(false);
//     } catch (error) {
//       console.error('Submit failed:', error);
//       setSnackbarMessage('Failed to submit manual or video.');
//       setSnackbarSeverity('error');
//       setSnackbarOpen(true);
//     } finally {
//       setUploading(false);
//       setUploadProgress(0);
//     }
//   };

//   if (loading) {
//     return <LoadingSpinner size={30} />;
//   }

//   return (
//     <Box
//       sx={{
//         width: '100%',
//         mt: 8,
//         mb: 1,
//         borderRadius: 2,
//         boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
//         backgroundColor: '#fff',
//       }}
//     >
//       <Box
//         display="flex"
//         justifyContent="space-between"
//         alignItems="center"
//         bgcolor="rgba(195, 234, 203, 0.1)"
//         p={2}
//       >
//         <Typography variant="h4" component="h1" sx={{ fontWeight: 'bold' }}>
//           Manuals and Videos
//         </Typography>
//         <Button variant="contained" color="primary" onClick={handleAddVideo} disabled={uploading}>
//           Add Manual/Video
//         </Button>
//       </Box>

//       <TableComponent
//         columns={columns}
//         rows={rows}
//         manageColumnStatus
//         enableSort
//         sx={{
//           '& .MuiDataGrid-columnHeaders': {
//             backgroundColor: '#1976d2',
//             color: '#fff',
//             fontWeight: 'bold',
//           },
//         }}
//       />

//       <Dialog open={openFormDialog} onClose={() => !uploading && setOpenFormDialog(false)}>
//         <DialogTitle>{isEditMode ? 'Edit Manual/Video' : 'Add Manual/Video'}</DialogTitle>
//         <DialogContent>
//           <TextField
//             margin="dense"
//             label="Subject"
//             fullWidth
//             value={formData.subject}
//             error={!!formErrors.subject}
//             helperText={formErrors.subject}
//             onChange={(e) => setFormData({ ...formData, subject: e.target.value })}
//             disabled={uploading}
//           />
//           <FormControlLabel
//             control={
//               <Checkbox
//                 checked={formData.is_internal}
//                 onChange={(e) => setFormData({ ...formData, is_internal: e.target.checked })}
//                 disabled={uploading}
//               />
//             }
//             label="Is Internal"
//           />
//           <Box mt={2}>
//             <input
//               accept="*"
//               style={{ display: 'block', marginTop: 8 }}
//               type="file"
//               onChange={handleFileChange}
//               disabled={uploading}
//             />
//             {formErrors.file && (
//               <Typography variant="body2" color="error" sx={{ mt: 1 }}>
//                 {formErrors.file}
//               </Typography>
//             )}
//             {isEditMode && !selectedFile && selectedVideo?.viewDetails && (
//               <Typography variant="body2" sx={{ mt: 1 }}>
//                 Current File:{' '}
//                 <a
//                   href={`${API_BASE_URL}${selectedVideo.viewDetails}`}
//                   target="_blank"
//                   rel="noopener noreferrer"
//                 >
//                   View Details
//                 </a>
//               </Typography>
//             )}
//           </Box>

//           {uploading && (
//             <Box sx={{ mt: 2 }}>
//               <LinearProgress variant="determinate" value={uploadProgress} />
//               <Typography variant="body2" sx={{ textAlign: 'center', mt: 1 }}>
//                 Uploading... {uploadProgress}%
//               </Typography>
//             </Box>
//           )}
//         </DialogContent>
//         <DialogActions>
//           <Button onClick={() => !uploading && setOpenFormDialog(false)} disabled={uploading}>
//             Cancel
//           </Button>
//           <Button variant="contained" color="primary" onClick={handleFormSubmit} disabled={uploading}>
//             {uploading ? <CircularProgress size={24} color="inherit" /> : isEditMode ? 'Update' : 'Add'}
//           </Button>
//         </DialogActions>
//       </Dialog>

//       <Dialog open={deleteDialogOpen} onClose={() => setDeleteDialogOpen(false)}>
//         <DialogTitle>Confirm Delete</DialogTitle>
//         <DialogContent>Are you sure you want to delete this manual or video?</DialogContent>
//         <DialogActions>
//           <Button onClick={() => setDeleteDialogOpen(false)} disabled={uploading}>
//             Cancel
//           </Button>
//           <Button variant="contained" color="error" onClick={handleDelete} disabled={uploading}>
//             Delete
//           </Button>
//         </DialogActions>
//       </Dialog>

//       <SnackBarComponent
//         open={snackbarOpen}
//         message={snackbarMessage}
//         severity={snackbarSeverity}
//         onClose={handleSnackbarClose}
//       />
//     </Box>
//   );
// };



import React, { useEffect, useState } from 'react';
import {
  Box, Typography, Button, Dialog, DialogActions,
  DialogContent, DialogTitle, TextField, IconButton,
  LinearProgress, Checkbox, FormControlLabel,
  CircularProgress,
} from '@mui/material';
import { Delete, Edit } from '@mui/icons-material';
import TableComponent from '../../../Components/TableComponent/TableComponent';
import { SnackBarComponent } from '../../../Components/snackBar/snackBar';
import { LoadingSpinner } from '../../../Components/spinner/spinner';
import { API_BASE_URL } from '../../../config';
import api from '../../../api/axiosInterceptor';
import axios from 'axios';

export const SuperStaffManualVideosComponent = () => {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);

  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [snackbarSeverity, setSnackbarSeverity] = useState('info');

  const [openFormDialog, setOpenFormDialog] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);
  const [selectedVideo, setSelectedVideo] = useState(null);

  const [formData, setFormData] = useState({
    subject: '',
    is_internal: false,
  });
  const [selectedFile, setSelectedFile] = useState(null);
  const [formErrors, setFormErrors] = useState({});

  const [uploading, setUploading] = useState(false);
  const [uploadProgress, setUploadProgress] = useState(0);

  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [deleteVideo, setDeleteVideo] = useState(null);

  const columns = [
    { id: 'slNo', field: 'slNo', headerName: 'Sl No.', width: 70 },
    {
      id: 'type',
      field: 'type',
      headerName: 'Type',
      width: 100,
      renderCell: (params) => (
        <Typography variant="body2" fontWeight="bold" color={params.value === 'Staff' ? 'primary.main' : 'secondary.main'}>
          {params.value}
        </Typography>
      ),
    },
    { id: 'subject', field: 'subject', headerName: 'Subject', width: 300 },
    {
      id: 'viewDetails',
      field: 'viewDetails',
      headerName: 'View Details',
      width: 120,
      renderCell: (params) =>
        params.value ? (
          <a href={params.value} target="_blank" rel="noopener noreferrer">
            View Details
          </a>
        ) : (
          'No File'
        ),
    },
    {
      id: 'is_internal',
      field: 'is_internal',
      headerName: 'Is Internal',
      width: 100,
      renderCell: (params) => (params.value ? 'Yes' : 'No'),
    },
    {
      id: 'actions',
      field: 'actions',
      headerName: 'Actions',
      width: 150,
      renderCell: (params) => (
        <>
          <IconButton color="primary" onClick={() => handleEdit(params.row)} disabled={uploading}>
            <Edit />
          </IconButton>
          <IconButton color="error" onClick={() => handleDeleteConfirmation(params.row)} disabled={uploading}>
            <Delete />
          </IconButton>
        </>
      ),
    },
  ];

  useEffect(() => {
    fetchVideos();
  }, []);

  // ONLY fetchVideos modified to get from both APIs
  const fetchVideos = async () => {
    setLoading(true);
    
    try {
      const [staffResponse, publicResponse] = await Promise.all([
        axios.get(`${API_BASE_URL}/home-notification/staff-manaual-vid/`),
        axios.get(`${API_BASE_URL}/home-notification/manaual-vid/`)
      ]);

      const staffData = staffResponse.data.map((item, index) => ({
        id: item.id || index,
        slNo: index + 1,
        subject: item.subject,
        viewDetails: item.link || '',
        is_internal: item.is_internal || true,
        type: 'Staff'
      }));

      const publicData = publicResponse.data.map((item, index) => ({
        id: item.id || staffData.length + index,
        slNo: staffData.length + index + 1,
        subject: item.subject,
        viewDetails: item.link || '',
        is_internal: item.is_internal || false,
        type: 'Public'
      }));

      const combinedData = [...staffData, ...publicData];
      setRows(combinedData);
    } catch (error) {
      console.error('Failed to fetch Manuals and Videos:', error);
      setSnackbarMessage('Failed to load Manuals and Videos.');
      setSnackbarSeverity('error');
      setSnackbarOpen(true);
    } finally {
      setLoading(false);
    }
  };

  const handleSnackbarClose = () => setSnackbarOpen(false);

  const handleAddVideo = () => {
    setIsEditMode(false);
    setFormData({ subject: '', is_internal: false });
    setSelectedFile(null);
    setFormErrors({});
    setUploadProgress(0);
    setOpenFormDialog(true);
  };

  const handleEdit = (video) => {
    setIsEditMode(true);
    setSelectedVideo(video);
    setFormData({ subject: video.subject, is_internal: video.is_internal || false });
    setSelectedFile(null);
    setFormErrors({});
    setUploadProgress(0);
    setOpenFormDialog(true);
  };

  const handleDeleteConfirmation = (video) => {
    setDeleteVideo(video);
    setDeleteDialogOpen(true);
  };

  // Uses ORIGINAL API endpoint for delete
  const handleDelete = () => {
    api
      .delete(`/home-notification/manaual-vid/${deleteVideo.id}/`)
      .then(() => {
        setSnackbarMessage('Manual or video deleted successfully.');
        setSnackbarSeverity('success');
        setSnackbarOpen(true);
        fetchVideos();
      })
      .catch((error) => {
        console.error('Delete failed:', error);
        setSnackbarMessage('Failed to delete manual or video.');
        setSnackbarSeverity('error');
        setSnackbarOpen(true);
      })
      .finally(() => {
        setDeleteDialogOpen(false);
        setDeleteVideo(null);
      });
  };

  const validateForm = () => {
    const errors = {};
    if (!formData.subject?.trim()) errors.subject = 'Subject is required';
    if (!selectedFile && !isEditMode) errors.file = 'File is required';
    if (selectedFile && selectedFile.size > 2 * 1024 * 1024) errors.file = 'File size must be less than 2MB';
    setFormErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file && file.size > 2 * 1024 * 1024) {
      setFormErrors((prev) => ({ ...prev, file: 'File size must be less than 2MB' }));
      setSelectedFile(null);
    } else {
      setFormErrors((prev) => ({ ...prev, file: null }));
      setSelectedFile(file);
    }
  };

  // Uses ORIGINAL API endpoints for create/update
  const handleFormSubmit = async () => {
    if (!validateForm()) return;

    const form = new FormData();
    form.append('subject', formData.subject);
    form.append('is_internal', formData.is_internal);
    if (selectedFile) form.append('link', selectedFile);

    try {
      setUploading(true);
      setUploadProgress(0);

      if (isEditMode) {
        await api.patch(`/home-notification/manaual-vid/${selectedVideo.id}/`, form, {
          headers: { 'Content-Type': 'multipart/form-data' },
          onUploadProgress: (e) => setUploadProgress(Math.round((e.loaded * 100) / e.total)),
        });
        setSnackbarMessage('Manual or video updated successfully.');
      } else {
        await api.post(`/home-notification/manaual-vid/`, form, {
          headers: { 'Content-Type': 'multipart/form-data' },
          onUploadProgress: (e) => setUploadProgress(Math.round((e.loaded * 100) / e.total)),
        });
        setSnackbarMessage('Manual or video added successfully.');
      }

      setSnackbarSeverity('success');
      setSnackbarOpen(true);
      fetchVideos();
      setOpenFormDialog(false);
    } catch (error) {
      console.error('Submit failed:', error);
      setSnackbarMessage('Failed to submit manual or video.');
      setSnackbarSeverity('error');
      setSnackbarOpen(true);
    } finally {
      setUploading(false);
      setUploadProgress(0);
    }
  };

  if (loading) {
    return <LoadingSpinner size={30} />;
  }

  return (
    <Box
      sx={{
        width: '100%',
        mt: 8,
        mb: 1,
        borderRadius: 2,
        boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
        backgroundColor: '#fff',
      }}
    >
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        bgcolor="rgba(195, 234, 203, 0.1)"
        p={2}
      >
        <Typography variant="h4" component="h1" sx={{ fontWeight: 'bold' }}>
          Manuals and Videos (All)
        </Typography>
        <Button variant="contained" color="primary" onClick={handleAddVideo} disabled={uploading}>
          Add Manual/Video
        </Button>
      </Box>

      <TableComponent
        columns={columns}
        rows={rows}
        manageColumnStatus
        enableSort
        sx={{
          '& .MuiDataGrid-columnHeaders': {
            backgroundColor: '#1976d2',
            color: '#fff',
            fontWeight: 'bold',
          },
        }}
      />

      <Dialog open={openFormDialog} onClose={() => !uploading && setOpenFormDialog(false)}>
        <DialogTitle>{isEditMode ? 'Edit Manual/Video' : 'Add Manual/Video'}</DialogTitle>
        <DialogContent>
          <TextField
            margin="dense"
            label="Subject"
            fullWidth
            value={formData.subject}
            error={!!formErrors.subject}
            helperText={formErrors.subject}
            onChange={(e) => setFormData({ ...formData, subject: e.target.value })}
            disabled={uploading}
          />
          <FormControlLabel
            control={
              <Checkbox
                checked={formData.is_internal}
                onChange={(e) => setFormData({ ...formData, is_internal: e.target.checked })}
                disabled={uploading}
              />
            }
            label="Is Internal (Staff Only)"
          />
          <Box mt={2}>
            <input
              accept="*"
              style={{ display: 'block', marginTop: 8 }}
              type="file"
              onChange={handleFileChange}
              disabled={uploading}
            />
            {formErrors.file && (
              <Typography variant="body2" color="error" sx={{ mt: 1 }}>
                {formErrors.file}
              </Typography>
            )}
            {isEditMode && !selectedFile && selectedVideo?.viewDetails && (
              <Typography variant="body2" sx={{ mt: 1 }}>
                Current File:{' '}
                <a
                  href={selectedVideo.viewDetails}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  View Details
                </a>
              </Typography>
            )}
          </Box>

          {uploading && (
            <Box sx={{ mt: 2 }}>
              <LinearProgress variant="determinate" value={uploadProgress} />
              <Typography variant="body2" sx={{ textAlign: 'center', mt: 1 }}>
                Uploading... {uploadProgress}%
              </Typography>
            </Box>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => !uploading && setOpenFormDialog(false)} disabled={uploading}>
            Cancel
          </Button>
          <Button variant="contained" color="primary" onClick={handleFormSubmit} disabled={uploading}>
            {uploading ? <CircularProgress size={24} color="inherit" /> : isEditMode ? 'Update' : 'Add'}
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog open={deleteDialogOpen} onClose={() => setDeleteDialogOpen(false)}>
        <DialogTitle>Confirm Delete</DialogTitle>
        <DialogContent>Are you sure you want to delete this manual or video?</DialogContent>
        <DialogActions>
          <Button onClick={() => setDeleteDialogOpen(false)} disabled={uploading}>
            Cancel
          </Button>
          <Button variant="contained" color="error" onClick={handleDelete} disabled={uploading}>
            Delete
          </Button>
        </DialogActions>
      </Dialog>

      <SnackBarComponent
        open={snackbarOpen}
        message={snackbarMessage}
        severity={snackbarSeverity}
        onClose={handleSnackbarClose}
      />
    </Box>
  );
};
